/**
 * @format
 * @module lib/commercial/keytar/newsletter-story-regwall/template
 */
import Template, {
  BLOCKOUT_TYPES,
  shouldShowTeaserRendering
} from "lib/commercial/keytar/Template";
import { setUpTeaserView } from "lib/commercial/keytar/common/teaser";
import { isDesktop } from "utils/detect";
import tgamConfig from "config/tgam";
import { hasProp } from "utils/utils";
import isNil from "lodash/isNil";

/** @type {String} */
const wallType = "registeredPaywall";
const wallName = "registerWall";

let blockoutType =
  isDesktop() || tgamConfig.meta.isStoryInteractivePage
    ? BLOCKOUT_TYPES.EVERYTHING // static modal displayed
    : BLOCKOUT_TYPES.HEADER_NAV_ACCESSIBLE; // iframe takeover displayed

const showTeaserRendering = shouldShowTeaserRendering("regWall");
if (showTeaserRendering) {
  blockoutType = BLOCKOUT_TYPES.PREVIEW;
}

const props = {
  blockoutType,
  darwinRenderKey: wallType,
  /**
   * @method render
   * @description Always render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    /**
     * In the Darwin test variant.js script, an object is passed containing
     * the properties: `url`, and an optional `height` and `width` that are used for the iFrame, i.e.
     * window.tgam.darwin.setKeytarWall("registeredPaywall", "modal/teaser", {
     *  url: "https://....",
     *  height: 400,
     *  width: 200,
     * });
     */
    let { darwinTemplate, viewType, paragraphs } = this.darwinRendering();
    const { url, width, height } = darwinTemplate || {};
    if (isNil(viewType) && showTeaserRendering) {
      this.updateTeaserAnalytics(paragraphs);
      viewType = "teaser";
    }
    if (viewType === "teaser") {
      const wallConfig = { url, height };
      const contentType = this.parentContext.contentType;
      setUpTeaserView(wallType, wallConfig, paragraphs, contentType);
      return Promise.resolve(true);
    }

    // This is setup in: /resources/scripts/src/ui/user-states.js
    if (hasProp(window, "tgam.ui.regwall.show")) {
      window.tgam.ui.regwall.show({
        url,
        width,
        height,
        uid: "regwall",
        wallName,
        template: darwinTemplate
      });
    }
    return Promise.resolve(true);
  }
};

export default new Template(props);
